<div class="spacing-top">
	<div data-testid="SUBSYS4_TEMPLATE_SELECTION_CANCEL_BTN" class="wrapper-back" (click)="back()" (keypress)="back()">
		<span class="material-icons md-18 back">arrow_back</span>
		<span class="action">{{ labels().TEMPLATE_SELECTION_COMPONENT_CANCEL_BTN }}</span>
	</div>
</div>

<div class="main-step">
	<div class="box-menu-settings active">

		<div class="wrapper-select-accordion">

			@if (filtersForm) {
			<form [formGroup]="filtersForm">

				<div class="row-box">
					<div class="form-group">
						<label class="mb-0" for="AnatomicalSite">{{ labels().TEMPLATE_SELECTION_COMPONENT_ANATOMICAL_SITE }}</label>
						<div>{{ siteFilterLabel(filtersForm.value.site || '-') }}</div>
					</div>
				</div>

				<div class="row-box pt-0">
					<div class="form-group">
						<label class="mb-0" for="Screw">{{ labels().TEMPLATE_SELECTION_COMPONENT_SCREW}}</label>
						<div class="form-group">
							<select class="form-control custom-select" id="Screw" formControlName="screw" (change)="updateScrew()">
								<option [ngValue]="null">-</option>
								@for (screw of prodSrv.screwList | async; track screw) {
								<option [ngValue]="screw">{{screw}}</option>
								}
							</select>
						</div>
					</div>
				</div>
				@if (filtersForm.value.site === siteFilterEnum.PROX_DIST_TIBIA) {
				<div class="row-box pt-0">
					<div class="form-group">
						<label class="mb-0" for="Segment">{{ labels().TEMPLATE_SELECTION_COMPONENT_SEGMENT }}</label>
						<div class="form-group">
							<select class="form-control custom-select" id="Segment" formControlName="segment"
								(change)="updateSegment()">
								<option [ngValue]="null">-</option>
								@for (segment of prodSrv.segmentList | async; track segment) {
								<option [ngValue]="segment">{{segment}}</option>
								}
							</select>
						</div>
					</div>
				</div>
				}
				@if (filtersForm.value.site === siteFilterEnum.PROXIMAL_FEMUR || filtersForm.value.site ===
				siteFilterEnum.DISTAL_FEMUR) {
				<div class="row-box pt-0">
					<div class="form-group">
						<label class="mb-0" for="Angle">{{ labels().TEMPLATE_SELECTION_COMPONENT_ANGLE }}</label>
						<div class="form-group">
							<select class="form-control custom-select" id="Angle" formControlName="angle" (change)="updateAngle()">
								<option [ngValue]="null">-</option>
								@for (angle of prodSrv.angleList | async; track angle) {
								<option [ngValue]="angle">{{angle}}</option>
								}
							</select>
						</div>
					</div>
				</div>
				}
				@if (filtersForm.value.site === siteFilterEnum.PROXIMAL_FEMUR) {
				<div class="row-box pt-0">
					<div class="form-group">
						<label class="mb-0" for="Offset">{{ labels().TEMPLATE_SELECTION_COMPONENT_OFFSET }}</label>
						<div class="form-group">
							<select class="form-control custom-select" id="Offset" formControlName="offset" (change)="updateOffset()">
								<option [ngValue]="null">-</option>
								@for (offset of prodSrv.offsetList | async; track offset) {
								<option [ngValue]="offset">{{offset}}</option>
								}
							</select>
						</div>
					</div>
				</div>
				}
				@if (filtersForm.value.site === siteFilterEnum.DISTAL_FEMUR) {
				<div class="row-box pt-0">
					<div class="form-group">
						<label class="mb-0" for="Flare">{{ labels().TEMPLATE_SELECTION_COMPONENT_FLARE }}</label>
						<div class="form-group">
							<select class="form-control custom-select" id="Flare" formControlName="flare" (change)="updateFlare()">
								<option [ngValue]="null">-</option>
								@for (flare of prodSrv.flareList | async; track flare) {
								<option [ngValue]="flare">{{flare}}</option>
								}
							</select>
						</div>
					</div>
				</div>
				}
				<div class="row-box pt-0">
					<div class="form-group">
						<label class="mb-0" for="Holes">{{ labels().TEMPLATE_SELECTION_COMPONENT_HOLES }}</label>
						<div class="form-group">
							<select class="form-control custom-select" id="Holes" formControlName="holes" (change)="updateHoles()">
								<option [ngValue]="null">-</option>
								@for (holes of prodSrv.holesList |async; track holes) {
								<option [ngValue]="holes">{{holes}}</option>
								}
							</select>
						</div>
					</div>
				</div>
				<div class="row-box">
					<div class="box-suggestion">
						<p>
							{{ labels().TEMPLATE_SELECTION_COMPONENT_MESSAGE }}
						</p>
					</div>
				</div>
				@if (this.filtersForm.value.screw) {
				<div class="row-box pt-0">
					<div class="w-100">
						<h4 class="mb-3">
							{{ labels().TEMPLATE_SELECTION_COMPONENT_RESULTS }} &nbsp; {{ ($plateNameList | async)?.length }}
						</h4>
						<div class="result-filter" [class.loading]="isAPPlateLoading || isLTPlateLoading">
							@for (plateName of $plateNameList | async; track plateName) {
							<div (click)="insertPlate($index)" (keypress)="insertPlate($index)">{{ plateName }}</div>
							}
						</div>
					</div>
				</div>
				}
				<div class="row-box">
					<div class="form-group">
						<label class="" for="plateOrientation">{{ labels().TEMPLATE_SELECTION_COMPONENT_PLATE_ORIENTATION }}</label>
						<div class="form-group">
							<div class="custom-control custom-radio custom-control-inline pt-0" (click)="setLateral()"
								(keypress)="setLateral()">
								<input type="radio" id="lateral" name="plateOrientation" class="custom-control-input"
									[value]="plateOrientationType.lateral" formControlName="plateOrientation" />
								<label class="custom-control-label" for="lateral">
									{{ labels().TEMPLATE_SELECTION_COMPONENT_PLATE_LATERAL }}</label>
							</div>
							<div class="custom-control custom-radio custom-control-inline pt-0" (click)="setMedial()"
								(keypress)="setMedial()">
								<input type="radio" id="medial" name="plateOrientation" class="custom-control-input"
									[value]="plateOrientationType.medial" formControlName="plateOrientation" />
								<label class="custom-control-label" for="medial">
									{{ labels().TEMPLATE_SELECTION_COMPONENT_PLATE_MEDIAL }}</label>
							</div>
						</div>
					</div>
				</div>

				<div class="bottom-margin"></div>
				<div class="container-btn-confirm">
					<div class="divider-box"></div>
					<div class="wrapper-btn-confirm">
						<button data-testid="SUBSYS4_TEMPLATE_SELECTION_CONFIRM_BTN" type="button" class="btn btn-primary px-2"
							[disabled]="!isPlateInserted" (click)="confirmTemplate()">
							{{ labels().TEMPLATE_SELECTION_COMPONENT_BUTTON }}
						</button>
					</div>
				</div>

			</form>
			}

		</div>

	</div>
</div>